export const QuestionCategoryIcon = () => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.86572"
        y="3.22388"
        width="9.31343"
        height="7.34328"
        rx="1.43284"
      />
      <rect
        x="2.86572"
        y="13.4328"
        width="9.31343"
        height="7.34328"
        rx="1.43284"
      />
      <rect
        x="13.791"
        y="3.22388"
        width="9.31343"
        height="7.34328"
        rx="1.43284"
      />
      <g clip-path="url(#clip0_519_215)">
        <path d="M19.1802 18.4819H17.4515V18.3096C17.4515 18.0159 17.484 17.7768 17.5508 17.5935C17.6177 17.4086 17.717 17.2424 17.849 17.0905C17.981 16.9381 18.2774 16.6709 18.739 16.2888C18.9847 16.0884 19.1073 15.9051 19.1073 15.7389C19.1073 15.5711 19.0576 15.4424 18.9599 15.3491C18.8605 15.2575 18.7114 15.2111 18.511 15.2111C18.2951 15.2111 18.1179 15.2823 17.9765 15.4253C17.8352 15.5667 17.7452 15.8168 17.706 16.1707L15.9403 15.9515C16.001 15.3022 16.2368 14.7804 16.647 14.384C17.0584 13.9882 17.6894 13.791 18.5386 13.791C19.2 13.791 19.7328 13.9291 20.1397 14.204C20.6913 14.5784 20.9679 15.0753 20.9679 15.697C20.9679 15.9548 20.8967 16.2049 20.7537 16.444C20.6124 16.6831 20.3203 16.9768 19.8808 17.3213C19.5749 17.5654 19.3806 17.7591 19.3 17.9071C19.221 18.0529 19.1802 18.2456 19.1802 18.4819ZM17.3913 18.9418H19.2442V20.5761H17.3913V18.9418Z" />
      </g>
      <defs>
        <clipPath id="clip0_519_215">
          <rect
            width="5.02762"
            height="6.78448"
            transform="translate(15.9403 13.791)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default QuestionCategoryIcon;
